import { render } from "./LabelData.vue?vue&type=template&id=2914c3f2"
import script from "./LabelData.vue?vue&type=script&lang=js"
export * from "./LabelData.vue?vue&type=script&lang=js"

import "./LabelData.vue?vue&type=style&index=0&id=2914c3f2&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__